async function handleAuthCartSubmit(e){
    e.preventDefault();
    AuthCartUtils.setLoading(true);
    var { error } = await stripe.confirmPayment({
        elements,
        confirmParams: {
            return_url: ecomConf.returnUrl,
        },
    });
    if( typeof error !== 'undefined' ){
        if (error.type === "card_error" || error.type === "validation_error") {
            AuthCartUtils.showMessage(error.message);
        } else {
            AuthCartUtils.showMessage("An unexpected error occurred.");
        }
    }

    AuthCartUtils.setLoading(false);
}